import { MutableRefObject, useEffect, useRef } from "react"

export const usePreviousTyped = <T>(value: T, initialValue?: T): MutableRefObject<T | undefined>["current"] => {
    const ref = useRef<T | undefined>(initialValue)
    useEffect(() => {
        ref.current = value
    }, [value])
    return ref.current
}

export const usePreviousManualUpdate = <T>(initialValue?: T): { ref: MutableRefObject<T | undefined>; update: (newValue: T) => void } => {
    const ref = useRef<T | undefined>(initialValue)
    const update = (newValue: T) => {
        ref.current = newValue
    }
    return { ref, update }
}
